import type { MascotScene, MascotTopic } from "./runtime";

// The remaining homepage sky stop explains the real workflow.
const skyTopics: MascotTopic[] = [
  {
    id: "sky-start",
    label: "Как зажечь свою звёздочку?",
    title: "Начать можно с Неба",
    text:
      "Открой Небо Светлячков. Можно создать новую страницу питомца прямо оттуда или выбрать уже созданную страничку питомца, у которого ещё нет звезды.\n\nВыбери свободное место и цвет, затем сохрани звёздочку. Для этого нужно войти в аккаунт. У каждого питомца может быть одна звезда.",
    link: { href: "/sky", label: "Перейти в Небо Светлячков" },
  },
  {
    id: "sky-stories",
    label: "Можно просто посмотреть Небо?",
    title: "За каждой звёздочкой — история",
    text:
      "Да. Смотреть Небо и читать публичные истории можно без регистрации. Выбери звёздочку, познакомься с её питомцем и открой страницу памяти.\n\nВ небольшом фрагменте на главной показаны только публичные страницы. Можно просто побыть рядом — создавать свою страницу сразу не обязательно.",
    link: { href: "/faq#faq-7", label: "Подробнее о Небе" },
  },
  {
    id: "sky-privacy",
    label: "Кто увидит мою звезду?",
    title: "Ты выбираешь, чем поделиться",
    text:
      "У звезды и страницы питомца одна настройка публичности. Публичная звезда открывает твою историю другим посетителям Неба. Непубличная страница исключается из общего поиска. Её звезда на Небе Светлячков становится белой, а для других посетителей вместо имени питомца показывается «Звёздочка». Но точная ссылка всё ещё может открываться у того, кому ты её отправишь.\n\nМесто и цвет своей звезды можно менять. Если убрать её из Неба, страница, фотографии и воспоминания сохранятся.",
    link: { href: "/faq#faq-2", label: "О публичности и доступе по ссылке" },
  },
];

export const homepageScenes: MascotScene[] = [
  {
    section: "#home-welcome",
    anchor: "#mascot-welcome",
    theme: "dark",
    title: "Привет. Я рядом.",
    text:
      "Я помогу познакомиться со Светлячками. Прокручивай страницу — я полечу рядом. Нажми на меня, если хочется узнать больше. Начать можно с Неба Светлячков и зажечь там звёздочку, посвящённую своему ушедшему питомцу. Или сразу создать страничку памяти.",
    action: { href: "/sky", label: "Зажечь звёздочку" },
    topics: [
      {
        id: "first-step",
        label: "С чего можно начать?",
        title: "Одной фотографии уже достаточно",
        text:
          "Создай страницу питомца: имя и одна фотография — уже начало. Любимую привычку, смешной случай и другие воспоминания можно добавить позже.\n\nУ этой истории нет обязательного темпа. Можно зажечь звёздочку на Небе Светлячков или просто посмотреть, как здесь всё устроено.",
        link: { href: "/faq#faq-1", label: "О страницах памяти" },
      },
      {
        id: "account",
        label: "Для чего нужен аккаунт?",
        title: "Твои воспоминания остаются с тобой",
        text:
          "Без регистрации можно читать публичные страницы, блог и смотреть чужие истории на Небе Светлячков. Аккаунт нужен, чтобы создать свою страницу, сохранить звезду, участвовать в чате и зажигать светлячков на чужих страничках.",
        link: { href: "/faq#faq-8", label: "Об аккаунте" },
      },
      {
        id: "visibility",
        label: "Нужно ли делиться со всеми?",
        title: "Ты решаешь, чем поделиться",
        text:
          "Публичность страницы и видимость каждой анкеты настраиваются отдельно. Не обязательно открывать все воспоминания.\n\nНепубличная страница не появляется в общих разделах, но она будет открываться, если поделиться её точной ссылкой.",
        link: { href: "/faq#faq-2", label: "О публичности" },
      },
    ],
  },
  {
    section: "#home-memory",
    anchor: "#mascot-memory",
    theme: "dark",
    title: "Как мы обнимаем",
    text:
      "Память складывается из маленьких деталей. А поддержка — из простых жестов.\n\nВыбери, о чём рассказать. Здесь можно читать понемногу и возвращаться к темам в своём темпе.",
    topics: [
      {
        id: "chat",
        label: "Что такое чат поддержки?",
        title: "Чат тепла — место, где можно быть рядом",
        text:
          "В нашем чате можно поделиться историей питомца, поддержать другого человека или просто побыть рядом с теми, кто понимает ценность такой памяти. К сообщению можно прикрепить страницу питомца или публичную анкету.\n\nДля участия нужно войти в аккаунт. Мы просим бережно относиться к чувствам друг друга. Чат сообщества не заменяет профессиональную или экстренную помощь.",
        link: { href: "/faq#faq-9", label: "Подробнее о чате и общении" },
      },
      {
        id: "surveys",
        label: "Зачем нужны анкеты?",
        title: "Анкеты с воспоминаниями",
        text:
          "Мы создавали вопросы вместе с психологом. Любимая привычка, смешной случай, момент знакомства — анкеты помогают сохранить маленькие детали, из которых складывается твоя история.\n\nМожно писать понемногу, пропускать вопросы с помощью «Не сейчас» и возвращаться позже. Сохрани уже написанные ответы, чтобы продолжить в другой день.\n\nЕсли пока не хочется делиться воспоминанием, выключи «Анкета видна всем» и сохрани её. Анкета останется доступной тебе, но не другим посетителям.",
        link: { href: "/faq#faq-3", label: "Об анкетах и воспоминаниях" },
      },
      {
        id: "fireflies",
        label: "Что означают светлячки?",
        title: "Светлячки в окне памяти",
        text:
          "Тихое «я рядом». Один огонёк — небольшой знак внимания от человека, который прочитал твою историю. Зажечь светлячка можно и на своей странице, и на странице другого питомца.\n\nНа один огонёк нужен один свет из твоего запаса. Запас постепенно восстанавливается, а зажжённые светлячки со временем гаснут.\n\nПока на странице есть хотя бы один активный светлячок, растения в окне памяти растут. Без света рост приостанавливается, но не начинается заново.",
        link: { href: "/faq#faq-4", label: "О свете, светлячках и растениях" },
      },
      {
        id: "tributes",
        label: "Как работают посвящения и подарки?",
        title: "Тёплые слова и подарки",
        text:
          "Посвящение — несколько тёплых слов для питомца и его человека. К нему можно добавить маленький подарок.\n\nПосвящения от других людей появляются на странице только после одобрения её владельцем. Ты выбираешь, что останется на странице.\n\nНекоторые подарки связаны со стикерами. После одобрения посвящения такой подарок можно отдельно разместить в окне памяти — он не появляется там автоматически.",
        link: { href: "/faq#faq-5", label: "О посвящениях и подарках" },
      },
    ],
  },
  {
    section: "#home-sky-discovery",
    anchor: "#mascot-sky-discovery",
    theme: "dark",
    title: "Давай познакомимся с одной историей",
    text:
      "Каждая звёздочка связана со страницей питомца. Звёздочки на этой странице выбраны случайно. Здесь можно познакомиться с одной историей.\n\nЕсли готов начать свою — можно начать с Неба Светлячков и зажечь на нём звёздочку. Я расскажу, как выбрать место и сохранить её.",
    action: { href: "/sky", label: "Открыть Небо Светлячков" },
    topics: skyTopics,
  },
  {
    section: "#home-how-it-works",
    anchor: "#mascot-how-it-works",
    theme: "dark",
    title: "Собери свой маленький мир",
    text:
      "Окно памяти — маленькая сцена на странице твоего питомца. В ней найдётся место для любимых деталей и тёплых воспоминаний.\n\nЗдесь можно попробовать: «Поместить стикер» сначала добавит котика, затем собачку. Перетащи их туда, где нравится. Это только пример — настоящая страница и твой запас света не меняются.",
    action: { href: "/pets/create", label: "Создать свою страничку" },
    topics: [
      {
        id: "page-start",
        label: "Как создать страницу?",
        title: "Первый маленький шаг",
        text:
          "Для создания страницы понадобится аккаунт. Начни с имени и фотографии питомца. Остальные детали можно заполнить позже — не нужно вспоминать всё сразу.",
        link: { href: "/faq#faq-1", label: "О создании страницы" },
      },
      {
        id: "window",
        label: "Что такое окно памяти?",
        title: "Собери свой маленький мир",
        text:
          "Окно памяти — оформление страницы питомца. Выбери фон, добавь стикеры, размести светлячков и посади цветок. Элементы можно двигать, менять их размер и порядок.\n\nЭто твоя композиция, которую можно менять и дополнять. Анкеты с воспоминаниями живут рядом — отвечай только на те вопросы, на которые сейчас хочется.",
        link: { href: "/faq#faq-6", label: "Об оформлении окна" },
      },
      {
        id: "window-demo",
        label: "Как попробовать здесь?",
        title: "Два стикера — твоя композиция",
        text:
          "Нажми «Поместить стикер»: сначала появится котик, затем собачка. Маленькая картинка на кнопке показывает, кто следующий.\n\nДвигай стикеры мышью или пальцем. Нажми на стикер — за угловой маркер можно поменять размер. На клавиатуре работают стрелки, Shift ускоряет перемещение, Delete убирает стикер. «Очистить пример» позволяет начать заново.\n\nЭтот пример не сохраняется и не тратит свет. На своей странице ты оформляешь настоящее окно памяти в редакторе и сохраняешь изменения.",
        link: { href: "/faq#faq-6", label: "Об оформлении окна" },
      },
      {
        id: "sharing",
        label: "Как поделиться с близкими?",
        title: "Выбери, чем поделиться",
        text:
          "Настрой публичность страницы и отдельных анкет, сохрани изменения и отправь близким ссылку, когда будешь готов. Можно оставить часть воспоминаний только для себя.",
        link: { href: "/faq#faq-2", label: "О видимости страницы" },
      },
    ],
  },
  {
    section: "#home-growth",
    anchor: "#mascot-growth",
    theme: "dark",
    title: "Свет помогает расти",
    text:
      "Цветы памяти — живые стикеры в окне твоего питомца. Пока на странице есть светлячки, цветок проходит путь от ростка до цветения.\n\nНа главной можно запустить ускоренный пример: на пятом дне свет погаснет и рост подождёт тебя. Зажги ещё свет в примере — цветок продолжит расти. Настоящий запас света здесь не расходуется.",
    action: { href: "/faq#faq-6", label: "Как оформить окно памяти" },
    topics: [
      {
        id: "plant",
        label: "Как посадить цветок?",
        title: "Растение — живой стикер",
        text:
          "В оформлении окна памяти можно выбрать цветок или дерево и разместить его как стикер. По мере роста меняется его внешний вид.\n\nВ одном окне памяти можно разместить до пяти растений. Одновременно в окне может быть только одно незавершённое растение. Чтобы посадить следующее, дождись, пока предыдущее вырастет, или убери его в запас и посади другое. Накопленный рост убранного растения сохранится.\n\nСейчас доступны цветы и дерево. Цветам нужны десять дней накопленного света, дереву — 365 дней: за первый месяц оно проходит первые пять стадий, дальше растёт равномерно. Кустик пока в разработке.",
        link: { href: "/faq#faq-6", label: "О стикерах и оформлении" },
      },
      {
        id: "growth-time",
        label: "Когда цветок распустится?",
        title: "Десять дней накопленного света",
        text:
          "Для полного роста цветку нужны десять дней освещения, не обязательно подряд. Стадии этого цветка начинаются на 0, 1, 3, 6 и 10 днях накопленного света.\n\nНа главной кнопка «Зажечь свет» показывает ускоренный пример — десять секунд роста вместо настоящих дней, по секунде на каждый сегмент шкалы. На пятом дне он остановится без света; после «Зажечь ещё свет» продолжится до цветения. Время ожидания твоего нажатия не входит в эти десять секунд. Это не ускоряет настоящее растение и не тратит твой запас света.",
        link: { href: "/faq#faq-4", label: "О свете и росте" },
      },
      {
        id: "pause",
        label: "Что будет без светлячков?",
        title: "Рост подождёт тебя",
        text:
          "Цветок растёт, пока на странице есть хотя бы один активный светлячок. Их можешь зажигать ты и другие посетители.\n\nЕсли огоньки погасли, рост приостанавливается, но пройденный путь не теряется. Новый свет продолжит его с того же места. В примере это произойдёт на пятом дне: нажми «Зажечь ещё свет», чтобы продолжить с середины, а не начинать сначала. Пятый день — сценарий демонстрации, не обязательный срок жизни настоящего светлячка.",
        link: { href: "/faq#faq-4", label: "О светлячках" },
      },
    ],
  },
  {
    section: "#home-warmth",
    anchor: "#mascot-warmth",
    theme: "dark",
    title: "Тепло может остаться в окне памяти",
    text:
      "Светлячок, несколько тёплых слов или маленький подарок — разные способы сказать «я рядом». Пройди пример: подарок из посвящения сможет остаться в окне памяти.",
    action: { href: "/sky", label: "Найти историю в Небе" },
    topics: [
      {
        id: "gestures",
        label: "Как можно передать тепло?",
        title: "Выбери свой жест",
        text:
          "Зажги светлячка на своей или чужой странице либо оставь посвящение — несколько тёплых слов. К посвящению можно приложить подарок.\n\nЭто отдельные жесты, не обязательный набор. Можно выбрать только то, что хочется сделать. Для настоящего действия нужно войти в аккаунт, а владелец должен разрешить посвящения и светлячков.",
        link: { href: "/faq#faq-5", label: "О посвящениях" },
      },
      {
        id: "light-cost",
        label: "Сколько света потребуется?",
        title: "Маленькие жесты и запас света",
        text:
          "Один светлячок стоит 1 свет. Посвящение без подарка — тоже 1 свет, а с подарком — 2 света всего. Если сделать оба жеста, они оплачиваются отдельно.\n\nЗапас восстанавливается постепенно — по одной единице за прошедший день, до семи единиц. Перед настоящим подтверждением сайт покажет стоимость. Пример на главной ничего не тратит и никому не отправляет.",
        link: { href: "/faq#faq-4", label: "О запасе света" },
      },
      {
        id: "gift-approval",
        label: "Как подарок попадёт в окно?",
        title: "С разрешения владельца",
        text:
          "Посвящение от другого человека сначала видит владелец страницы. Он решает, опубликовать его или отклонить.\n\nНекоторые подарки, например рыбка в этом примере, связаны со стикерами. После одобрения владелец сам решает, отдельно разместить ли подарок в окне памяти. Автоматического размещения нет.",
        link: { href: "/faq#faq-5", label: "О подарках и одобрении" },
      },
    ],
  },
  {
    section: "#home-blog",
    anchor: "#mascot-blog",
    theme: "dark",
    title: "Бережные истории",
    text:
      "В блоге можно почитать о любви, памяти и поддержке после утраты питомца. Здесь показываем по две опубликованные статьи: стрелки перелистывают подборку, а карточка открывает материал целиком. Можно читать в своём темпе.",
    action: { href: "/blog", label: "Открыть блог" },
    topics: [
      {
        id: "stories",
        label: "Что есть в блоге?",
        title: "Можно просто почитать",
        text:
          "В блоге мы собираем бережные материалы о любви, памяти и переживании утраты питомца. Статьи можно читать без регистрации.\n\nВ полном блоге также есть памятка о том, как поддержать себя и близких в период потери.",
        link: { href: "/blog", label: "Все материалы блога" },
      },
      {
        id: "reading",
        label: "Нужно ли рассказывать свою историю?",
        title: "В своём темпе",
        text:
          "Нет. Можно только почитать, закрыть статью и вернуться к ней позже. Общаться, создавать страницу или рассказывать о питомце прямо сейчас не обязательно.",
        link: { href: "/blog", label: "Открыть блог" },
      },
    ],
  },
  {
    section: "#home-support",
    anchor: "#mascot-support",
    theme: "dark",
    title: "Спасибо, что ты здесь",
    text:
      "Мы создаём место, где можно сохранить любовь и найти поддержку после утраты питомца. Если тебе близко то, что мы делаем, можешь помочь Светлячкам расти.",
    action: { href: "/about-us", label: "Узнать о проекте" },
    topics: [
      {
        id: "support",
        label: "Как поддержать проект?",
        title: "Чтобы света становилось больше",
        text:
          "Кнопка «Поддержи проект» в этом блоке открывает нашу страницу пожертвований на Donatty. Пожертвование добровольное: решение и сумму выбираешь ты.\n\nНе обязательно делать это сейчас — спасибо, что ты здесь.",
        link: { href: "/about-us", label: "О Светлячках" },
      },
      {
        id: "other-help",
        label: "Можно поддержать иначе?",
        title: "Тёплые жесты тоже важны",
        text:
          "Можно почитать чью-то историю, оставить бережные слова, рассказать о Светлячках человеку, которому такое место сейчас нужно. Выбери то, что тебе подходит.",
        link: { href: "/sky", label: "Познакомиться с историями" },
      },
    ],
  },
  {
    section: "#home-community",
    anchor: "#mascot-community",
    theme: "dark",
    title: "Здесь можно быть рядом",
    text:
      "В чате тепла можно поделиться воспоминанием или просто побыть среди тех, кто понимает. Это самостоятельное место для общения, не служба поддержки сайта.",
    action: { href: "/faq#faq-9", label: "О чате и правилах общения" },
    topics: [
      {
        id: "community-chat",
        label: "О чём можно поговорить в чате?",
        title: "Здесь можно быть рядом",
        text:
          "Расскажи о питомце, поделись воспоминанием, прикрепи его страницу или публичную анкету. Для участия понадобится вход.\n\nПожалуйста, бережно относись к чувствам других людей: не обесценивай переживания и не навязывай единственный правильный путь. Это чат сообщества, не профессиональная или экстренная помощь.",
        link: { href: "/faq#faq-9", label: "О чате и правилах общения" },
      },
      {
        id: "participation",
        label: "Можно просто почитать?",
        title: "Разговор — по желанию",
        text:
          "Да. Не обязательно писать сообщение или рассказывать свою историю. Если захочешь участвовать в разговоре, понадобится вход в аккаунт.\n\nПожалуйста, бережно относись к другим участникам: это чат сообщества, не профессиональная или экстренная помощь.",
        link: { href: "/faq#faq-9", label: "О чате" },
      },
    ],
  },
  {
    section: "#home-questions",
    anchor: "#mascot-questions",
    theme: "dark",
    title: "Ответы всегда под рукой",
    text:
      "В FAQ собраны ответы о страницах памяти и механиках Светлячков. Можно выбрать раздел или найти нужный вопрос через поиск.",
    action: { href: "/faq", label: "Все вопросы и ответы" },
    topics: [
      {
        id: "questions",
        label: "Какие ответы там есть?",
        title: "О том, как устроен сайт",
        text:
          "В FAQ объясняем страницы памяти, публичность, анкеты, свет, растения, подарки и Небо. Ответы сгруппированы по разделам — можно сразу перейти к нужной теме.",
        link: { href: "/faq", label: "Открыть вопросы и ответы" },
      },
      {
        id: "search",
        label: "Как найти нужный вопрос?",
        title: "Не нужно читать всё сразу",
        text:
          "Открой FAQ и введи слово в поле «Найти ответ». Поиск работает по вопросам и ответам. Если ничего не нашлось, попробуй другое слово или выбери раздел.",
        link: { href: "/faq", label: "Найти ответ" },
      },
    ],
  },
];
